// src/components/posts/ReactionButtons.js
import React from 'react';
import '../../styles/reaction-buttons.css';

const ReactionButtons = ({ onLike, onComment, onShare, isLiked }) => {
  return (
    <div className="reaction-buttons">
      <button 
        className={`reaction-button like-button ${isLiked ? 'active' : ''}`} 
        onClick={onLike}
      >
        <i className="reaction-icon like-icon">❤️</i>
        <span className="reaction-label">Like</span>
      </button>
      
      <button className="reaction-button comment-button" onClick={onComment}>
        <i className="reaction-icon comment-icon">💬</i>
        <span className="reaction-label">Comment</span>
      </button>
      
      {/* <button className="reaction-button share-button" onClick={onShare}>
        <i className="reaction-icon share-icon">🔄</i>
        <span className="reaction-label">Share</span>
      </button> */}
    </div>
  );
};

export default ReactionButtons;